import { render, staticRenderFns } from "./IndexTheme.vue?vue&type=template&id=af7f7e50&scoped=true&"
import script from "./IndexTheme.vue?vue&type=script&lang=ts&"
export * from "./IndexTheme.vue?vue&type=script&lang=ts&"
import style0 from "./IndexTheme.vue?vue&type=style&index=0&id=af7f7e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7f7e50",
  null
  
)

export default component.exports